import React from "react";
import WobbleCard from "../components/wobbleCard/wobbleCard"; 
import "../styles/uiCss/WobbleCard.css";

const WobbleCards = () => {
  // Detect mobile width without a hook
  const isMobile = window.innerWidth <= 768;

  return (
    <div
      className="wobblecards-container"
      style={{
        flexDirection: isMobile ? "column" : "row",
        
      }}
    >
      {/* Card 1 - Why Phonics is Important */}
      <WobbleCard containerClassName="blue-card">
        <div className="wobblecard-content">
          <h2
            className="wobblecard-title"
            style={{
              marginBottom: isMobile ? "30px" : "50px",
              fontSize: isMobile ? "20px" : "30px",
            }}
          >
            🧠 Why Phonics is Important
          </h2>
          <div className="wobblecard-list">
            <p>1. Builds a strong foundation for reading</p>
            <p>2. Helps children decode new or unfamiliar words</p>
            <p>3. Improves spelling</p>
            <p>4. Boosts reading fluency and confidence</p>
          </div>
        </div>
      </WobbleCard>

      {/* Card 2 - Fun Ways to Teach Phonics */}
      <WobbleCard containerClassName="blue-card">
        <div className="wobblecard-content">
          <h2
            className="wobblecard-title"
            style={{
              marginBottom: isMobile ? "30px" : "50px",
              fontSize: isMobile ? "20px" : "30px",
            }}
          >
            🎲 Fun Ways to Teach Phonics
          </h2>
          <div className="wobblecard-list">
            <p>1. Flashcards with letter-sound pictures</p>
            <p>2. Rhyming games</p>
            <p>3. Singing phonics songs</p>
            <p>4. Interactive apps and games</p>
            <p>5. Phonics-based readers (simple storybooks)</p>
          </div>
        </div>
      </WobbleCard>
    </div>
  );
};

export default WobbleCards;
